import React, { useEffect, useRef, useState } from 'react';
import './Post.css';
import VideoCard from '../../../Components/VideoCard';
import { useCart } from '../../../CartProvider';
import { HashLoader } from 'react-spinners';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant';

const parseAvatarKey = (key) => {
    try {
        const parsedKey = JSON.parse(key);
        return Array.isArray(parsedKey) ? parsedKey : JSON.parse(parsedKey);
    } catch (error) {
        console.error('Failed to parse Attachment_Keys:', error);
        return [];
    }
};

function Post({ results, searchTerm, lastElementRef, loading }) {
    const validResults = results || [];
    const videoRefs = useRef([]);
    const [activeVideoIndex] = useState(null);
    const [activeUnmutedId, setActiveUnmutedId] = useState(null);
    const { coordinate } = useCart();

    const filteredPosts = validResults.filter((post) =>
        post?.Vendor_Info?.[0]?.Vendor_Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleVideoRef = (ref, index) => {
        if (ref) {
            videoRefs.current[index] = ref;
        }
    };

    const handleGlobalMuteChange = () => {
        // videoRefs.current.forEach((video, i) => {
        //     if (video) {
        //         video.muted = i !== index;
        //     }
        // });
        // setActiveVideoIndex(index);
    };


    useEffect(() => {
        if (window.innerWidth >= 801 || !filteredPosts.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;
                    if (entry.isIntersecting && video.readyState >= 3) {
                        video.play().catch((error) => console.error('Video play error:', error));
                    } else {
                        video.pause();
                    }
                });
            },
            { threshold: 0.75 }
        );

        videoRefs.current.forEach((videoRef) => {
            if (videoRef && videoRef.src) {
                observer.observe(videoRef);
            }
        });
        

        return () => observer.disconnect();
    }, [filteredPosts, activeUnmutedId]);

    return (
        <div className="media-post-reels">
            <Helmet>
                <title>{SEO.POSTS_PAGE.TITLE}</title>
                <meta name="description" content={SEO.POSTS_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.POSTS_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                                   
                <meta property="og:title" content={SEO.POSTS_PAGE.TITLE} />
                <meta property="og:description" content={SEO.POSTS_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.POSTS_PAGE.OG.TYPE} />
                <meta property="og:site_name" content={SEO.POSTS_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                   
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.POSTS_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.POSTS_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
                                
            </Helmet>
            <div className='main-container profile-main-container' style={{ flexDirection: 'column' }}>
                <div className='video-container profile-video-container'>
                    {filteredPosts?.length > 0 && (
                        filteredPosts?.map((post, index) => (
                            (post?.Attachment_keys || [])?.map((attachment) => {
                                const avatarUrls = parseAvatarKey(attachment?.Avatar_key || '[]');

                                return avatarUrls?.map((url, avatarIndex) => {
                                    const isLastElement = index === filteredPosts?.length - 1 && avatarIndex === avatarUrls?.length - 1;
                                    return (<div className="profile-post" key={post?.Post_ID} ref={isLastElement ? lastElementRef : null}>
                                        <VideoCard
                                            key={post?.Post_ID}
                                            id={post?.Post_ID}
                                            vendorID={post?.Post_Vendor_id}
                                            AccountID={post?.User_Info?.User_ID}
                                            url={url}
                                            attachmentKeys={post?.Attachment_keys || []}
                                            profilePic={post?.User_Info?.Profile_Picture || ''}
                                            firstName={post?.User_Info?.First_Name || ''}
                                            lastName={post?.User_Info?.Last_Name || ''}
                                            userName={post?.User_Info?.Username || ''}
                                            restaurantName={post?.Vendor_Info?.[0]?.Vendor_Name || ''}
                                            starPic={post?.Restaurant_Info?.[0]?.Star_Image || ''}
                                            rating={post?.Vendor_Info?.[0]?.Vendor_Avg_Rating || 0}
                                            distance={post?.Vendor_Info?.[0]?.Vendor_Distance || 0}
                                            description={post?.Post_Description}
                                            likes={post?.Post_Likes_count}
                                            shares={post?.Post_Shares_count}
                                            comments={post?.Post_Comments_count}
                                            setLike={() => { }}
                                            activeUnmutedId={activeUnmutedId}
                                            setActiveUnmutedId={setActiveUnmutedId}
                                            index={index}
                                            ismuted={activeVideoIndex !== index}
                                            setVideoRef={(ref) => handleVideoRef(ref, index)}
                                            handleGlobalMuteChange={() => handleGlobalMuteChange(index)}
                                            autoplay={index === 0}
                                            restaurant={filteredPosts}
                                            coordinate={coordinate}
                                            likeFlag={post?.LikedFlag}
                                            saveFlag={post?.SavedFlag}
                                            itemName={post?.Menu_items_Info?.[0]?.Menu_item_Name || ''}
                                            vendorAddress={
                                                `${post?.Vendor_Info?.[0]?.Vendor_Address || ''}, ${post?.Vendor_Info?.[0]?.Vendor_City || ''}, ${post?.Vendor_Info?.[0]?.Vendor_State || ''}, ${post?.Vendor_Info?.[0]?.Vendor_PostalCode || ''}, ${post?.Vendor_Info?.[0]?.Vendor_Country || ''}`
                                            }
                                            followFlag={post?.FollowFlag}
                                            filter={post?.Post_filter || ''}
                                            reelsId={post?.Post_ID}
                                            user_Rating_count={post?.Vendor_Info?.[0]?.Vendor_Review_User_Count}
                                        />
                                    </div>);
                                });
                            })
                        ))
                    )}
                    {!loading && results && results.length === 0 && (
                        <div className="no-reels-and-images-message no-post" >
                            No Posts Available.
                        </div>
                    )}

                </div>
                {loading &&
                    <div className='search-onload-loader'>
                        <HashLoader
                            color="#E13535"
                            loading={true}
                            size={50}
                        />
                    </div>
                }
            </div>
        </div>
    );
}
export default Post;
